import { useEffect, useState } from "react";
import Stripe from "stripe";

export function useStripePrices(params: Stripe.PriceListParams): Stripe.Price[] {
	const [prices, setPrices] = useState<Stripe.Price[]>([]);

	useEffect(() => {
		fetch("/api/prices/list", {
			headers: { "Content-Type": "application/json" },
			method: "POST",
			body: JSON.stringify(params)
		})
			.then(res => res.json())
			.then((prices: Stripe.ApiList<Stripe.Price>) => {
				setPrices(prices.data);
			});

		return () => setPrices([]);
	}, []);

	return prices;
}